/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../models/amplify/API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const triggerOngoingCallsUpdate = /* GraphQL */ `mutation TriggerOngoingCallsUpdate {
  triggerOngoingCallsUpdate {
    callSid
    callId
    pin
    clientNumber
    callStatus
    operators {
      operatorId
      operatorName
      __typename
    }
    outboundPhoneNumbers
    customInputFields {
      name
      value
      isEnabled
      criteriaType
      __typename
    }
    callStartedAt
    durationMilliseconds
    languageName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.TriggerOngoingCallsUpdateMutationVariables,
  APITypes.TriggerOngoingCallsUpdateMutation
>;
